import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/_work/holibob/holibob/booking-web/contexts/ApolloProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/home/runner/_work/holibob/holibob/booking-web/contexts/Providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useViewer"] */ "/home/runner/_work/holibob/holibob/booking-web/hooks/useViewer.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/_work/holibob/holibob/node_modules/.pnpm/next@14.2.3_@babel+core@7.27.1_@opentelemetry+api@1.7.0_@playwright+test@1.48.2_babel-plugin-_7dccd4xjmxtxepr4ojsv5si6ei/node_modules/next/dist/client/script.js");
